import { render, staticRenderFns } from "./RealtimeKpiStrip.vue?vue&type=template&id=bb8b822e&scoped=true"
import script from "./RealtimeKpiStrip.vue?vue&type=script&lang=js"
export * from "./RealtimeKpiStrip.vue?vue&type=script&lang=js"
import style0 from "./RealtimeKpiStrip.vue?vue&type=style&index=0&id=bb8b822e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb8b822e",
  null
  
)

export default component.exports